<template>
  <!-- 监测中心 -->
  <div id="data-center">
    <!-- 一键收起 -->
    <el-tooltip
      class="item"
      effect="light"
      :content="isShift ? '一键收起' : '一键展开'"
      placement="left"
    >
      <div class="is-shift" @click="handleShift">
        <img src="/static/img/home/show.png" :style="{ transform: transform }">
      </div>
    </el-tooltip>
    <!-- 左侧上部的图标 -->
    <contentInfo :deviceInfo="deviceInfo" :left="contentInfoLeft" :deviceData="deviceData" />

    <!-- 左侧下部的紧急警告信息 -->
    <leftWarnList ref="leftWarnList" :warnList="warnList" :left="leftWarnListLeft" @handlealert="handlealert" />

    <!-- 地图 -->
    <div id="map-container"></div>

    <!-- marker信息框 -->
    <div ref="info_window" class="box" style="display: none">
      <infoWindow ref="infowindowChild" :basedata="basedata" @handleClose="handleClose" />
    </div>

    <!-- 警告框 -->
    <warinWindow
      ref="warnwindow"
      :is-warning="isWarning"
      :warning-base="warningBase"
      @closeWarning="closeWarning"
      @warnCloseinfo="warnCloseinfo"
    />
    <!-- 右侧统计信息 -->
    <rightToal ref="rightToal" :right="rightToalRight" />

    <!-- <div
      v-show="warnList.length"
      class="warn-list-c"
    >
      <h5>实时告警信息</h5>
      <div class="ul-box">
        <ul ref="ul">
          <li
            v-for="(list, index) in warnList"
            :key="index"
            @click="handlealert(list)"
          >
            <div class="item-warn">
              <h6>{{ list.info.warningTime }}</h6>
              <p>{{ list.info.msg }}</p>
            </div>
          </li>
        </ul>
      </div>
    </div> -->

    <!-- <audio
      loop
      ref='mp3'
    >
      <source
        src="/static/mp3/alarm.mp3"
        type="audio/mpeg"
      >
    </audio> -->
    <audio ref="audio" src="/static/mp3/alarm.mp3" loop></audio>
  </div>
</template>

<script>
import { formatDateTime } from '@/utils/objectUtil'
import { OPTION, realTimeOption, historyOption } from './config/index.js'
import { getData, getHistoryData } from './service.js'
// import TheHeader from '@/components/TheHeader'
import infoWindow from './components/infowindow'
import warinWindow from './components/warnWindow.vue'
import contentInfo from './components/contentInfo.vue'
import leftWarnList from './components/leftWarnList.vue'
import rightToal from './components/rightTotal.vue'
// import axios from 'axios'

import { mapGetters } from 'vuex'
import request from '@/utils/request'

export default {
  name: 'DataCenter',

  components: {
    // TheHeader,
    infoWindow,
    warinWindow,
    leftWarnList,
    contentInfo,
    rightToal,
  },

  data () {
    return {
      audioStop: true,
      connect: 0, // socket 连接次数
      // 请求路径
      path: {
        // 获取本地配置文件
        configPath: '/static/json/config.json',
        // 获取marker列表
        // markerListPath: '/static/json/dataMaker.json',
        markerListPath: '/api/device-info/all-install-devices',
      },
      // 是否展开侧边栏
      isShift: true,
      contentInfoLeft: 20,
      leftWarnListLeft: 20,
      rightToalRight: 20,
      transform: 'rotate(0deg)',
      map: null,
      basedata: {
        guid: '--',
        code: '--',
        name: '--',
        warnings: '--',
        installPosition: '--',
        online: '--',
        position: '--',
      },
      infoItem: null,
      isWarning: false,
      warningBase: {
        is_warning: false,
        msg: '位于XXX位置的道路安全监测系统设备（设备名称）触发报警，请及时处理！',
        type: '',
        deviceData: {
          code: '',
          online: '1',
          installLng: '',
          installLat: '',
        },
        warningTime: '',
      },
      mp3Dom: null,
      deviceInfo: {
        totalNum: '--',
        alarmTimes: '--',
        id: '',
        // alarmAll: {
        //   '000001': 0,
        //   '000002': 0,
        //   '000003': 0,
        // },
      },
      markerList: [],
      dataList: '',
      warnList: [],
      orginData: [],
      // 当前正在处理的报警marker
      warningMarkerDoing: {},
      warningNoreapeat: {},
      warningMarker: {},
      // timmer: null,
      timmer_warnChart: null,
      timmer_infoChart: null,
      ws: null,
      //
      deviceData: [
        {
          icon: 'blue-icon',
          number: '0',
          title: '在线',
          color: '#045ABB',
        },
        {
          icon: 'yellow-icon',
          number: '0',
          title: '离线',
          color: '#c3c3c3',
        },
        {
          icon: 'red-icon',
          number: '0',
          title: '报警',
          color: '#F91B26',
        },
      ],
    }
  },
  computed: {
    ...mapGetters(['currentTab']),
  },

  watch: {
    currentTab: {
      handler (groupId) {
        this.warnList = []
        this.refreshPageData(groupId)
      },
    },
  },
  created () {
    this.getDeviceData(this.currentTab)
  },

  mounted () {
    this.initMap()
    this.createWebSockets()
    this.refreshPageData(this.currentTab)
    document.addEventListener('mousemove', () => {
      this.timeCount = 0
      this.stopSound()
    })
  },
  beforeDestroy () {
    this.timmer_warnChart && clearInterval(this.timmer_warnChart)
    const { ws } = this
    ws && ws.close()
  },
  methods: {
    playSound () {
      this.audioStop = false
      this.$refs.audio && this.$refs.audio.play()
    },

    stopSound () {
      if (!this.audioStop) {
        this.$refs.audio && this.$refs.audio.pause()
        this.audioStop = true
      }
    },

    refreshPageData (groupId) {
      this.map.clearMap()
      this.$refs.infowindowChild && this.$refs.infowindowChild.handleClose()
      this.$refs.leftWarnList && this.$refs.leftWarnList.getListReq(groupId) // 刷新左侧列表历史数据
      this.getDeviceData(groupId)
      this.$refs.rightToal.initChart(groupId)
      this.getMarkerData(groupId)
      this.$refs.rightToal.getStatisHandle({ type: this.$refs.rightToal.date, groupId })
    },
    /**
     * @description: 初始化地图
     * @return       [description]
     */
    initMap () {
      // let { path: { configPath }, $http } = this

      this.map = new AMap.Map('map-container', {
        viewMode: '3D',
        pitch: 42,
        zooms: [8, 19],
        expandZoomRange: true,
        showBuildingBlock: false,
        mapStyle: 'amap://styles/ab56ea6d2065aadeee5cb62e09b107a1',
      })
      // 获取配置文件的地图中心和zoom
      // $http.get(configPath).then(res => {
      //   if (res.code === 'success') {
      //     // 定位中心
      //     this.map.setCenter(res.data.center)
      //     // zooms
      //     this.map.setZoom(res.data.zoom)
      //   }
      // })
    },
    getMarkerData (groupId = null) {
      let self = this
      let {
        path: { markerListPath },
        $http,
        $refs,
      } = this
      this.map.remove(this.markerList)

      $http.get(markerListPath, { groupId }).then(res => {
        let {
          code,
          msg,
          data: { list },
        } = res

        this.orginData = [...list]

        if (code === 'success') {
          this.dataList = list
          this.deviceInfo.totalNum = list.length
          // let iconConfig = [
          //   '/static/img/home/mapMarkerBlue.png',
          //   '/static/img/home/mapMarkerYellow.png',
          //   '/static/img/home/mapMarkerRed.gif',
          // ]
          const markerPath = iconName => {
            return '/static/img/home/marker/' + iconName
          }
          // 哨兵二代 icon
          let sentryIcon = [
            markerPath('collide_blue.png'),
            markerPath('collide_gray.png'),
            markerPath('collide_red.png'),
          ]
          // 瞭望者 icon
          let outLookIcon = [
            markerPath('curve_blue.png'),
            markerPath('curve_gray.png'),
            markerPath('curve_red.png'),
          ]
          // 设备icon偏移位置，不设置默认为左上角
          let offsetConfig = [[-40, -43], [-42, -40], [-40, -43]]

          this.markerList = []
          let positions = []
          list.forEach(val => {
            if (![1, 2].includes(val.groupId)) {
              // 暂时只 显示 瞭望者和哨兵二代 marker delete
              return
            }
            let { id, installPosition, installLat, installLng, online, warnings, groupId } = val
            if (!installLat || !installLng) return
            positions.push([installLng, installLat])
            let deviceStatic = warnings >= 1 ? 3 : online ? 1 : 2
            val.deviceStatic = deviceStatic

            var marker = new AMap.Marker({
              position: new AMap.LngLat(installLng, installLat),
              icon: (() => {
                if (groupId === 1) {
                  return sentryIcon[deviceStatic - 1]
                } else if (groupId === 2) {
                  return outLookIcon[deviceStatic - 1]
                }
              })(),
              title: installPosition,
              offset: new AMap.Pixel(
                offsetConfig[deviceStatic - 1][0],
                offsetConfig[deviceStatic - 1][1]
              ),
            })
            if (deviceStatic === 3) {
              marker.setLabel({
                offset: new AMap.Pixel(-150, -50),
                content: `<div class='red-info'>${installPosition}</div>`, // 设置文本标注内容
                direction: 'right', // 设置文本标注方位
              })
            }
            marker.id = id

            AMap.event.addListener(marker, 'click', function () {
              let temp = $refs.info_window
              self.infoItem = self.getInfoWindowData(val, temp, marker)
              self.infoItem.open(self.map, marker.getPosition())
              self.setWarnWindowChart(marker.id, 'info')
            })

            this.markerList.push(marker)
          })
          this.map.clearMap()
          this.map.add(this.markerList)
          let polygon = new AMap.Polygon({
            path: positions,
            map: this.map,
            strokeOpacity: 0,
            fillOpacity: 0,
            bubble: true,
          }) // 根据 marker 坐标 创建一个多边形
          let overlaysList = this.map.getAllOverlays('polygon') // 获取多边形 以 让地图自适应显示带该区域
          this.map.setFitView(overlaysList)

          // this.timmer && clearInterval(this.timmer)
          this.pollingData(groupId)
          // this.timmer = setInterval(() => {
          //   // console.log(this.timmer)
          //   this.pollingData()
          // }, 3000)
        } else {
          console.warn('接口请求失败', msg)
        }
      })
    },
    getInfoWindowData (val, temp, marker) {
      // const lng = marker.getPosition().getLng() - 0.00001
      // const lat = marker.getPosition().getLat()
      // let moveLngLat = [lng, lat]
      // this.map.panTo(moveLngLat)
      this.map.panTo(marker.getPosition())

      // val.alarmTimes = this.deviceInfo.alarmAll[val.id]
      val.position = `${val.installLng}, ${val.installLat}`
      this.basedata = { ...val }
      this.getRealTimeData(val.id, this.basedata.groupId)

      temp.style.display = 'block'

      var infoWindow = new AMap.InfoWindow({
        content: (item => {
          let box = document.createElement('div')
          box.appendChild(temp)
          return box
        })(),
        offset: new AMap.Pixel(0, -31),
        isCustom: true,
        anchor: 'center',
      })

      if (!val.deviceStatic) {
        infoWindow = new AMap.InfoWindow({
          content: `该设备（设备ID: ${val.id}）已掉线`,
          offset: new AMap.Pixel(0, -31),
        })
      }
      return infoWindow
    },
    /**
     * @description: 长连接
     * @param        {[type]} code [description]
     * @return       {[type]}      [description]
     */
    createWebSockets () {
      this.interval && clearInterval(this.interval) // 清除 socket 重连定时器
      let { id } = this.$store.state
      const wsUri = `${location.protocol.startsWith('https:') ? 'wss' : 'ws'}://${
        location.host
      }/api/wss?userId=${id}`

      const websocket = new WebSocket(wsUri)

      websocket.onerror = e => {
        console.log('websocket通信失败!', e)
        if (this.connect < 10) {
          this.connect++
          setTimeout(() => {
            this.createWebSockets()
          }, 10 * 1000)
        }
      }

      websocket.onopen = () => {
        // websocket.send()
        console.log('开始')
        this.interval = setInterval(() => {
          websocket.send(JSON.stringify({ type: 'ping' }))
        }, 5000)
      }

      websocket.onclose = () => {
        console.log('结束')
        this.interval && clearInterval(this.interval)
      }

      websocket.onmessage = e => {
        const data = JSON.parse(e.data)
        if (data) {
          try {
            let {
              id,
              deviceId,
              content,
              handleId,
              handleRealname,
              handleState,
              result,
              remarks,
              info,
              warningTime,
              type,
              cameraNum,
            } = data
            let marker = this.markerList.find(marker => marker.id === deviceId)
            let msg = `报警终端[${info.name}]触发报警，请及时处理！`
            let warningTimes = formatDateTime(new Date(warningTime), 'yyyy-MM-dd HH:mm:ss')

            let temp = {
              marker,
              info: {
                id,
                deviceId,
                msg,
                content,
                handleId,
                handleRealname,
                handleState,
                result,
                remarks,
                warningTime: warningTimes,
                type,
                deviceData: info,
                cameraNum,
              },
            }
            this.handlealert(temp)
            this.warnList.unshift(temp)

            // 更新页面组件相关数据
            const groupId = this.currentTab
            this.getDeviceData(groupId)
            this.$refs.rightToal.initChart(groupId)
            this.isWarning = true
            this.playSound()
          } catch (e) {
            console.error(e)
          }
        } else {
          console.log('ERROR: 推送的数据无效')
        }

        // if (res.respCode === 'success') {
        //   // 如果处于连接状态，则关闭
        //   if (websocket.readyState === 1) {
        //     websocket.close()
        //   }

        // }
      }

      this.ws = websocket
    },
    handleClose () {
      this.timmer_warnChart && clearInterval(this.timmer_warnChart)
      this.infoItem && this.infoItem.close()
    },
    closeWarning () {
      // let { baseData, marker } = this.warningMarkerDoing
      this.timmer_warnChart && clearInterval(this.timmer_warnChart)
      // 隐藏警告框
      this.isWarning = false
      this.refreshPageData(this.currentTab)
    },
    warnCloseinfo () {
      this.isWarning = false
      this.stopSound()
    },
    handlealert (item) {
      this.handleClose()
      this.warningMarkerDoing = item
      let { marker, info } = item
      if (!marker) {
        return
      }
      const lng = marker.getPosition().getLng() - 0.00001
      const lat = marker.getPosition().getLat() + 0.0009
      let moveLngLat = [lng, lat]
      this.map.setZoom(19)
      this.map.panTo(moveLngLat)
      this.warningBase = { ...info }
      this.isWarning = true
      this.warningBase.msg = `${formatDateTime(
        new Date(info.warningTime),
        'yyyy-MM-dd HH:mm:ss'
      )}, 智慧护栏碰撞报警系统报警信息 <span class="warn-position">（位于${info.deviceData.installPosition || '--'}的道路安全监测管理系统设备（${
        info.deviceData.name4Company
      }）触发报警）</span>，请及时处理！`

      // 设置echarts的data
      // this.setWarnWindowChart(marker.id, 'warnning')
      this.getRealTimeData(marker.id, 'warnning')
    },
    pollingData (groupId = null) {
      this.$http
        .get('/api/device-warning-info/list', { type: 0, groupId, pageIndex: 1, pageSize: 100 })
        .then(res => {
          if (res.code === 'success') {
            if (!res.data.list) {
              return
            }
            let data = [...res.data.list]
            let temp = data.map(
              ({
                id,
                deviceId,
                content,
                handleId,
                handleRealname,
                handleState,
                result,
                remarks,
                info,
                warningTime,
                type,
                cameraNum,
              }) => {
                let marker = this.markerList.find((marker, index) => marker.id === deviceId)
                // let msg = `报警终端[${id}]发生报警，请及时处理！`
                let msg = `报警终端[${info.name}]触发报警，请及时处理！`
                let warningTimes = formatDateTime(new Date(warningTime), 'yyyy-MM-dd HH:mm:ss')
                // warnRed.push({ marker, info: { id, msg, warningTime, type, deviceData: info }})
                return {
                  marker,
                  info: {
                    id,
                    deviceId,
                    msg,
                    content,
                    handleId,
                    handleRealname,
                    handleState,
                    result,
                    remarks,
                    warningTime: warningTimes,
                    type,
                    deviceData: info,
                    cameraNum,
                  },
                }
              }
            )
            this.warnList = temp
            this.warningMarker = { ...res.data }

            let tempArr = {}
            data.forEach(val => {
              if (!tempArr[val.deviceId]) {
                tempArr[val.deviceId] = []
              }
              tempArr[val.deviceId].push(val)
            })

            this.warningNoreapeat = tempArr
            // this.alartMsgList(temp, res.data)
          }
        })
    },
    // 实时数据1
    /**
     * @description:
     * @param        {number} id      marker的id
     * @param        {string} chartIs chats类型
     */
    setWarnWindowChart (id, chartIs) {
      // 找出该设备id
      let data = []
      for (let i in this.warningNoreapeat) {
        if (id === i) data = this.warningNoreapeat[i]
      }
      // 过滤的峰值数组
      let xAxisDatalists = []
      // 现在的时间戳3600000
      let nowTime = new Date().getTime()
      let tempData = []

      let setTime = chartIs === 'info' ? 600000 : 300000

      data.forEach(({ content, warningTime }) => {
        let time = formatDateTime(new Date(parseInt(warningTime)), 'HH:mm:ss')
        // 如果峰值时间已经超过5分钟则不插入
        if (nowTime - warningTime <= setTime) {
          tempData.push({ content })
          xAxisDatalists.push({ value: time, data: 15, time: parseInt(warningTime) })
        }
      })

      for (let i = 0; i < setTime / 2000 - tempData.length; i++) {
        nowTime -= 2000
        let temp = {
          value: formatDateTime(new Date(nowTime), 'HH:mm:ss'),
          data: (Math.random() * 0.5 + 5).toFixed(1),
          time: nowTime,
        }
        xAxisDatalists.push(temp)
      }

      let xAxisDatalist = xAxisDatalists.sort((a, b) => a.time - b.time)

      let option = JSON.parse(JSON.stringify(OPTION))
      option.series[0].data = xAxisDatalist.map(({ data }) => data)
      option.xAxis.data = xAxisDatalist

      // chartIs === 'warnning' && this.moveDatas(option, id)
      // chartIs === 'info' && this.moveMarker(option, id)
    },
    // 打开警告信息时，加速的的实时数据2
    moveDatas (option, id) {
      this.timmer_warnChart && clearInterval(this.timmer_warnChart)
      this.$refs.warnwindow.setChartOption(option)

      let oldTimes = this.deviceInfo.alarmTimes

      // 轮询插入数据
      this.timmer_warnChart = setInterval(() => {
        var data = option.series[0].data
        var axisData = formatDateTime(new Date(), 'HH:mm:ss')
        let temp = (Math.random() * 0.5 + 5).toFixed(1)

        if (this.deviceInfo.alarmTimes !== oldTimes && this.deviceInfo.id === id) {
          oldTimes = this.deviceInfo.alarmTimes
          temp = 16
        }
        data.push(temp)

        option.xAxis.data.push(axisData)

        data.shift()
        option.xAxis.data.shift()

        this.$refs.warnwindow.setChartOption(option)
      }, 3000)
    },
    // 打开marker时，加速的的实时数据2
    moveMarker (option, id) {
      this.timmer_warnChart && clearInterval(this.timmer_warnChart)
      this.$refs.infowindowChild.setChartOption(option)

      let oldTimes = this.deviceInfo.alarmTimes

      // 轮询插入数据
      this.timmer_warnChart = setInterval(() => {
        var data = option.series[0].data
        var axisData = formatDateTime(new Date(), 'HH:mm:ss')
        let temp = (Math.random() * 0.5 + 5).toFixed(1)
        // let max = option.yAxis.max

        if (this.deviceInfo.alarmTimes !== oldTimes && this.deviceInfo.id === id) {
          oldTimes = this.deviceInfo.alarmTimes
          temp = 16
          // temp = Math.round(Math.random() * 6 + 10)
          // max = max < temp ? (temp + 100) : option.yAxis.max
        }
        data.push(temp)

        option.xAxis.data.push(axisData)

        data.shift()
        option.xAxis.data.shift()

        // option.yAxis.max = max
        this.$refs.infowindowChild.setChartOption(option)
      }, 3000)
    },
    // 收起展开
    handleShift () {
      if (this.isShift) {
        this.contentInfoLeft = -515
        this.leftWarnListLeft = -430
        this.rightToalRight = -379
        this.transform = 'rotate(180deg)'
      } else {
        this.contentInfoLeft = 20
        this.leftWarnListLeft = 20
        this.rightToalRight = 20
        this.transform = 'rotate(0deg)'
      }
      this.isShift = !this.isShift
    },

    async getRealTimeData (deviceId, groupId) {
      // 为避免 实时数据 和 历史数据显示错误, 在请求数据前先置空 echarts
      this.$refs.infowindowChild.chart_line.clear()
      this.$refs.infowindowChild.loading = true
      if (groupId === 1) {
        let res = await getHistoryData({ deviceId })
        let option = JSON.parse(JSON.stringify(historyOption))
        if (res.code === 'success') {
          let xData = option.xAxis[0].data // 时间线`
          let xYData = option.series[0].data // 最大速度数据
          let yYData = option.series[1].data // 最大速度数据
          let zYData = option.series[2].data // 最大速度数据
          let list = res.data.list
          
          list &&
            list.forEach(item => {
              let date = item.time ? formatDateTime(new Date(item.time), 'yy-MM-dd HH:mm:ss') : ''
              xData.push(date)
              xYData.push(item.x)
              yYData.push(item.y)
              zYData.push(item.z)
            })

          this.$refs.infowindowChild.setChartOption(option)
        }
      } else if (groupId === 2) {
        let option = JSON.parse(JSON.stringify(realTimeOption))
        let res = await getData({ deviceId })
        if (res.code === 'success') {
          let { list } = res.data
          let xData = option.xAxis[0].data // 时间线
          let maxSpeedData = option.series[0].data // 最高车速
          let avgSpeedData = option.series[1].data // 平均车速
          let trafficFlow = option.series[2].data // 车流量
          list &&
            list.forEach(item => {
              xData.push(item.time ? item.time : '')
              maxSpeedData.push(item.maxSpeed)
              avgSpeedData.push(item.avgSpeed)
              trafficFlow.push(item.carFlow)
            })
          this.$refs.infowindowChild.setChartOption(option)
        }
      }
    },

    getDeviceData (groupId = null) {
      this.$http.get('/api/device-info/count', groupId ? { groupId } : null).then(res => {
        if (res.code === 'success') {
          res.data.list &&
            res.data.list.forEach(({ name, value }) => {
              if (name === 'online') {
                this.deviceData[0].number = value
              }
              if (name === 'offline') {
                this.deviceData[1].number = value
              }
              if (name === 'day-warning') {
                this.deviceData[2].number = value
              }
            })
        }
      })
    },
  },
}
</script>

<style lang="less">
#data-center {
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
  .is-shift {
    position: absolute;
    top: 100px;
    right: 2px;
    z-index: 9;
    border-top-left-radius: 50%;
    border-bottom-left-radius: 50%;
    width: 50px;
    height: 50px;
    line-height: 65px;
    text-align: center;
    background-color: rgba(18, 174, 241, 0.4);
    cursor: pointer;
    img {
      width: 30px;
      // margin-left: 15px;
    }
  }
  #map-container {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;

    .amap-logo {
      display: none !important;
    }
    .amap-copyright {
      display: none !important;
    }
  }
  .warn-list-c {
    width: 240px;
    // max-height: 600px;
    // max-height: 100vh;
    // overflow: auto;
    position: absolute;
    top: 100px;
    right: 10px;
    // background-color: rgba(25, 48, 138, 0.9);
    // border-top: 2px solid #5cf2e9;
    border-radius: 5px;
    padding: 20px;
    background: url('/static/img/home/list-bg.png') no-repeat;
    background-size: 100% 100%;
    animation: biling 0.8s ease-in infinite;
    /deep/ .el-alert__title {
      word-break: break-all;
    }
    .item-warn {
      color: #fff;
      font-size: 14px;
      background: url('/static/img/home/warin-item.png') no-repeat;
      background-size: 100% 100%;
      word-break: break-all;
      padding: 15px 10px;
      h6 {
        font-size: 15px;
      }
      p {
        //   display: inline-block;
        //   width: 150px;
        //   margin-left: 6px;
        margin-top: 6px;
        color: #12aef1;
      }
    }

    h5 {
      color: #12aef1;
      font-size: 18px;
      font-weight: bold;
      &::before {
        content: '';
        display: inline-block;
        width: 0;
        height: 10px;
        border: 2px solid #12aef1;
        margin-right: 10px;
      }
    }
    .ul-box {
      max-height: 600px;
      overflow: auto;
      margin-top: 5px;
      li {
        margin-top: 10px;
        cursor: pointer;
        // animation: biling 0.8s ease-in infinite;
      }
    }
  }
}
.red-info {
  color: #fff;
  background-color: #f91b26;
  width: 200px;
  line-height: 30px;
  // background: transparent url(/static/img/home/red.png);
  // background-size: 100% 100%;
  padding: 0 20px;
  border-radius: 4px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.amap-marker-label {
  border: 1px solid transparent;
  background-color: transparent;
}
@keyframes biling {
  from {
    box-shadow: 0px 0px 20px #fa0404;
  }
  50% {
    box-shadow: 0px 0px 0px #fa0404;
  }
  to {
    box-shadow: 0px 0px 20px #fa0404;
  }
}
</style>
